<template>
    <div class="model-assemble">
        <div class="model-assemble-header">
            <el-button icon="update-icon iconfont iconshangchuan" type="primary" @click="addModelAssembleHandle" round
                >&nbsp; LOD组装</el-button
            >
        </div>
        <el-table
            v-loading="isTableLoading"
            stripe
            style="width: 100%"
            :data="modelAssembleList"
            :header-cell-style="{
                'background-color': '#F5F5F5',
                'font-size': '14px',
                color: '#666666',
                'font-weight': '400',
            }"
            @selection-change="selectModelAssemble"
        >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="packageName" label="组装名称" width="180"></el-table-column>
            <el-table-column prop="startTime" label="开始时间" width="180">
                <template slot-scope="scope">
                    {{ formatTime(scope.row.startTime) }}
                </template>
            </el-table-column>
            <el-table-column prop="num" label="组装文件数"></el-table-column>
            <el-table-column prop="status" label="状态">
                <template>
                    <span style="color: #22c00e">组装成功</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <div class="icon-container">
                        <i @click="viewModelAssemble(scope.row)" title="查看" class="iconfont iconliulan-moren icon"></i
                        ><i
                            @click="editModelAssemble(scope.row)"
                            title="编辑"
                            class="iconfont iconcanshubianji icon"
                        ></i
                        ><i @click="shareModelAssemble(scope.row)" title="分享" class="iconfont iconfenxiang icon"></i
                        ><!--                    <i class="el-icon-share"></i>--><i
                            @click="delModelAssemble(scope.row)"
                            title="删除"
                            class="iconfont iconxingzhuang icon delete"
                        ></i>
                    </div>
                </template>
            </el-table-column>
        </el-table>

        <select-viewer-dialog
            @add-view="addView"
            @ok="saveModelAssemble"
            @close="closeDialog"
            :dialogVisible="dialogVisible"
            :beginStatus="beginStatus"
            :isLodState="true"
            title="LOD组装"
            :is-show2d="false"
            headerName="组装名称"
        >
            <show-model-position
                :data="addModelAssemble.packageParamsMetadataList"
                :isShowOperate="true"
                :removeView="removeView"
            ></show-model-position>
        </select-viewer-dialog>
        <el-dialog title="LOD组装参数编辑" :visible.sync="editDialogVisible" width="40%" :before-close="handleClose">
            <el-input
                style="padding: 0 80px 0 10px"
                class="dialog-name"
                placeholder="请输入内容"
                v-model.trim="editModelAssembleData.packageName"
            >
                <template slot="prepend">组装名称：</template>
            </el-input>
            <ShowModelPosition
                file-title="文件视图"
                :data="editModelAssembleData.packageParamsMetadataList"
            ></ShowModelPosition>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveModelAssemblePosition">保 存</el-button>
                <el-button @click="editDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <model-views-share ref="modelViewsShare" :jobType="'obmx-lod'"></model-views-share>
        <contact-us-com @send-message="sendMessage" ref="contactUsCom"></contact-us-com>
    </div>
</template>

<script>
import {
    addModelAssembleRequest,
    deleteModelAssemble,
    editModelAssembleView,
    getModelAssembleList,
    getModelAssembleView,
    tempGetModelAssembleList,
} from '../../../../utils/modelAssemble';
import { base64UrlEncode } from '../../../../utils/commonUtils';
import { formatTime } from '../../../../utils/commonUtils';
import { getAppInfo } from '../../../../utils/appUtils';
import { sendEmailToAccountUpgrade } from 'src/utils/sendMessage';
import SelectViewerDialog from '../ModelAssemble/SelectViewerDialog';
import ShowModelPosition from '../ModelAssemble/ShowModelPosition';
import ModelViewsShare from '../components/modelViews-share';
import ContactUsCom from '../components/contactUsCom';

class ModelAssembleTmp {
    packageName = '';
    num = 0;
    packageParamsMetadataList = [];
}
export default {
    name: 'modelAssemble',
    components: {
        ContactUsCom,
        ModelViewsShare,
        ShowModelPosition,
        SelectViewerDialog,
    },
    computed: {
        isTrial() {
            return this.userType === 'trial';
        },
    },
    data() {
        return {
            addModelAssemble: {},
            editModelAssembleData: {},
            dialogVisible: false,
            beginStatus: false,
            editDialogVisible: false,
            modelAssembleList: [],
            selectModels: [],
            userType: 'trial',
            isTableLoading: false,
        };
    },
    methods: {
        formatTime: formatTime,
        addModelAssembleHandle() {
            this.$message.warning('LOD组装已更新升级，请到【模型组装】页面查看！');
            // if (this.modelAssembleList.length >= 3 && this.isTrial) {
            //     this.$refs.contactUsCom.Open('你已达到模型组装个数的最大限制，请升级账户!');
            //     return;
            // }
            // this.dialogVisible = true;
            // this.beginStatus = false;
        },
        selectModelAssemble(data) {
            this.selectModels = data;
        },
        delModelList() {
            this.$confirm('确认删除选中的模型组装？')
                .then((_) => {
                    Promise.all(this.selectModels.map((item) => deleteModelAssemble(item.id))).then(() => {
                        this.$message.success('删除成功!');
                        this.getModelAssembleList();
                    });
                })
                .catch((_) => {});
        },
        saveModelAssemblePosition() {
            if (!this.editModelAssembleData.packageName) {
                this.$message.warning('请输入模型组装的名称!');
                return;
            }
            if (this._formatPosition(this.editModelAssembleData.packageParamsMetadataList)) {
                editModelAssembleView(
                    this.editModelAssembleData.packageName,
                    this.editModelAssembleData.packageParamsMetadataList,
                ).then(() => {
                    this.$message.success('修改成功!');
                    this.editDialogVisible = false;
                    this.editModelAssembleData = {};
                });
            }
        },
        viewModelAssemble(row) {
            this.$message.error('LOD组装已更新升级，请到【模型组装】页面查看！');
            // const tempURL = `${window.location.origin}/devcenter/console/view?name=${base64UrlEncode(
            //     row.packageName,
            // )}&viewModelType=assemble&assembleId=${row.id}&jobType=obmx-lod`;
            // window.open(tempURL, '_blank');
        },
        editModelAssemble(row) {
            getModelAssembleView(row.id).then((data) => {
                this.editModelAssembleData = row;
                this.editModelAssembleData.packageParamsMetadataList = data;
                this.editDialogVisible = true;
            });
        },
        delModelAssemble(row) {
            this.$confirm('确认删除的模型组装？')
                .then((_) => {
                    deleteModelAssemble(row.id).then(() => {
                        this.$message.success('删除成功!');
                        this.getModelAssembleList();
                    });
                })
                .catch((_) => {});
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        closeDialog() {
            this.addModelAssemble = new ModelAssembleTmp();
            this.dialogVisible = false;
        },
        saveModelAssemble(name) {
            if (!name) {
                this.$message.warning('请输入模型组装的名称!');
                return;
            }
            if (this.addModelAssemble.packageParamsMetadataList.length <= 0) {
                this.$message.warning('请选择视图!');
                return;
            }
            this.addModelAssemble.packageName = name;
            this.addModelAssemble.type = 1;
            this.addModelAssemble.num = this.addModelAssemble.packageParamsMetadataList.length;
            if (this._formatPosition(this.addModelAssemble.packageParamsMetadataList)) {
                this.beginStatus = true;
                addModelAssembleRequest(this.addModelAssemble)
                    .then(() => {
                        this.closeDialog();
                        this.getModelAssembleList();
                        this.$message.success('新增模型组装成功！');
                    })
                    .catch((e) => {
                        this.beginStatus = false;
                        this.$message.error('保存失败请重试!' + e);
                    });
            }
        },
        addView({ view }) {
            // 使用displayName 判断因为 文件的object key 不一样 但是 guid 会有可能一样
            const displayName = view.fileName;
            const item = this.addModelAssemble.packageParamsMetadataList.find(
                (item) => item.displayName === displayName,
            );
            if (item) {
                this.$message.warning('当前视图已经添加到已选文件视图中，不能重复添加!');
                return;
            }
            this.addModelAssemble.packageParamsMetadataList.push({
                guid: null,
                x: 0,
                y: 0,
                z: 0,
                r: 0,
                urn: view.seed,
                displayName,
            });
        },
        /*
         * LOD加载不需要guid
         * */
        // addView({view, object, urn }) {
        //     console.log({  view, object ,urn})
        //       // 使用displayName 判断因为 文件的object key 不一样 但是 guid 会有可能一样
        //       const displayName = object.fileName + '_' + view.name;
        //       const item = this.addModelAssemble.packageParamsMetadataList.find(
        //           (item) => item.displayName === displayName,
        //       );
        //       if (item) {
        //           this.$message.warning('当前视图已经添加到已选文件视图中，不能重复添加!');
        //           return;
        //       }
        //       this.addModelAssemble.packageParamsMetadataList.push({
        //           guid: view.guid,
        //           x: 0,
        //           y: 0,
        //           z: 0,
        //           r: 0,
        //           urn: urn,
        //           displayName,
        //       });
        //   },
        removeView(view) {
            const index = this.addModelAssemble.packageParamsMetadataList.findIndex(
                (item) => item.displayName === view.displayName,
            );
            if (index !== -1) {
                this.addModelAssemble.packageParamsMetadataList.splice(index, 1);
            }
        },
        async getModelAssembleList() {
            this.modelAssembleList = await tempGetModelAssembleList(); //使用临时的查询接口
        },
        _formatPosition(list) {
            list.forEach((item) => {
                // 校验数值正确
                let reg = /^(-?\d+)(\.\d+)?$/;
                if (reg.test(item.x) && reg.test(item.y) && reg.test(item.z) && reg.test(item.r)) {
                    item.x = typeof item.x !== '' ? parseFloat(item.x) : null;
                    item.y = typeof item.y !== '' ? parseFloat(item.y) : null;
                    item.z = typeof item.z !== '' ? parseFloat(item.z) : null;
                    item.r = typeof item.r !== '' ? parseFloat(item.r) : null;
                } else {
                    this.$message({
                        message: '不能输入非法字符',
                        type: 'warning',
                    });
                    return false;
                }
            });
            return true;
        },
        shareModelAssemble(row) {
            this.$message.error('LOD组装已更新升级，请到【模型组装】页面查看！')
            // this.fileName = row.packageName;
            // this.currentUrn = `bimbox.object:${row.packageName}`;
            // // 获取urn进行拼接
            // getModelAssembleView(row.id).then((data) => {
            //     let query = {
            //         cardName: row.packageName,
            //         guid: '',
            //         type: 5, // LOD组装分享
            //         packageId: row.id,
            //     };
            //     this.$refs.modelViewsShare.Open(
            //         {
            //             fileName: this.fileName,
            //             urn: this.currentUrn,
            //             objectStatus: {
            //                 obv: null,
            //                 lod: '完成转换',
            //             },
            //         },
            //         query,
            //     );
            // });
        },
        sendMessage(text) {
            if (!text) {
                this.$message.warning('联系内容不为空！');
                return;
            }
            // todo 后台接口限制 每10分钟 才能发一次
            sendEmailToAccountUpgrade(text)
                .then(() => {
                    this.$refs.contactUsCom.close();
                    this.$message.success('发送邮件成功！');
                })
                .catch((e) => {
                    let error = '';
                    if (e && e.responseText.indexOf('请求太频繁了，休息一会吧。') !== -1) {
                        error = '请求太频繁了，休息一会吧。';
                    }
                    this.$message.error(`发送失败！请重试${error}`);
                });
        },
    },
    async mounted() {
        this.isTableLoading = true;
        getAppInfo()
            .then((appRes) => {
                // 判断是否是第一次使用app
                if (appRes.items.length >= 0) {
                    // 账户状态 trial commercial
                    this.userType = appRes.items[0].type;
                }
            })
            .catch(() => {
                this.isTableLoading = false;
            });
        this.addModelAssemble = new ModelAssembleTmp();
        await this.getModelAssembleList();
        this.isTableLoading = false;
    },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.model-assemble
  width 88%
  .model-assemble-header
    padding 15px 15px
  .icon-container
    display flex
    align-items center
    .icon
      font-size 16px
      color $font-title
      opacity 0.6
      padding 0px 10px
      &:hover
        color #0C78E2
        opacity 1
        cursor pointer
    .icon.delete
      &:hover
        color rgb(255, 73, 41)
        opacity 1
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/lodAssemble/lodAssemble.vue